import { render } from "./PageViewPSBditerimaPelunasan.vue?vue&type=template&id=8cbce610&scoped=true"
import script from "./PageViewPSBditerimaPelunasan.vue?vue&type=script&lang=js"
export * from "./PageViewPSBditerimaPelunasan.vue?vue&type=script&lang=js"

import "./PageViewPSBditerimaPelunasan.vue?vue&type=style&index=0&id=8cbce610&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cbce610"]])

export default __exports__